import React from "react";
import { LockIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
type SectionCtaProps = {
  label: string;
  note?: string;
  dark?: boolean;
};
export function SectionCta({
  label,
  note = "One-time payment of $27 · Instant access · 7-day guarantee",
  dark = false
}: SectionCtaProps) {
  return <div className="mt-12 flex flex-col items-center text-center" data-id="element-61" data-mp="3nb8fpqv3exlb">
      <CtaButton label={label} data-id="element-62" data-mp="38n3vujkb0g0y" />
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-sm font-medium ${dark ? "text-white/75" : "text-muted"}`} data-id="element-63" data-mp="38mu5uvz9e8v9">
        <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-64" data-mp="2znh30m5n4iji" />
        {note}
      </p>
    </div>;
}